import React, { useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { MindMapTreeRoot } from "./MindMapTree";
import { MindMapEdges } from "./MindMapEdges";
import { useNodePositions } from "./hooks/useNodePositions";
import { collectEdges } from "./collectEdges";
import type { MindMapNode, ExpandedMap } from "./types";

interface MindMapCanvasProps {
  root: MindMapNode;
  expanded: ExpandedMap;
  onToggle: (id: string) => void;
  canvasRef?: React.RefObject<HTMLDivElement | null>;
}

export const MindMapCanvas: React.FC<MindMapCanvasProps> = ({
  root,
  expanded,
  onToggle,
  canvasRef,
}) => {
  const internalRef = useRef<HTMLDivElement>(null);
  const ref = canvasRef || internalRef;
  const positions = useNodePositions(ref, expanded);
  const edges = collectEdges(root, expanded);

  return (
    <div className="relative min-h-[280px] w-full overflow-hidden rounded-lg bg-card">
      <TransformWrapper
        initialScale={1}
        minScale={0.3}
        maxScale={2}
        wheel={{ step: 0.1 }}
        centerOnInit
      >
        <TransformComponent
          wrapperStyle={{ width: "100%", height: "100%", minHeight: "280px" }}
          contentStyle={{ width: "fit-content", minWidth: "100%", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "280px" }}
        >
          <div ref={ref} className="relative inline-flex items-center p-8">
            <MindMapEdges edges={edges} positions={positions} />
            <MindMapTreeRoot root={root} expanded={expanded} onToggle={onToggle} />
          </div>
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
};
